module.exports = __webpack_public_path__ + "static/Venafi-5c2e7ab6beb8e0f13b13e917102ff68f.pdf";